import _implicitStylesheets from "./securityReviewSubmissionFailed.css";
import _implicitScopedStylesheets from "./securityReviewSubmissionFailed.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _pageLink from "page/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="submitted-titles slds-size--1-of-1${0}"${2}><div class="slds-m-bottom--medium title${0}"${2}>${"t2"}</div></div>`;
const $fragment2 = parseFragment`<div class="slds-size_2-of-3 failed-state-text slds-m-left--medium${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<div class="slds-col loading-container slds-is-relative spinner-report${0}"${2}><div role="status" class="slds-spinner slds-spinner_small${0}"${2}><span class="slds-assistive-text${0}"${2}>${"t3"}</span><div class="slds-spinner__dot-a${0}"${2}></div><div class="slds-spinner__dot-b${0}"${2}></div></div></div>`;
const $fragment4 = parseFragment`<div class="slds-col${0}"${2}>${"t1"}</div>`;
const $fragment5 = parseFragment`<a class="failed-link failed-state-text slds-m-right--medium${0}"${2}><span class="slds-truncate${0}"${"a1:title"}${2}>${"t2"}</span></a>`;
const stc0 = {
  classMap: {
    "failed-state": true,
    "slds-m-vertical--large": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "slds-grid": true
  },
  key: 3
};
const stc2 = {
  key: 4
};
const stc3 = {
  props: {
    "size": "x-small",
    "iconName": "utility:file",
    "iconClass": "normal"
  },
  key: 5
};
const stc4 = {
  classMap: {
    "slds-col_bump-left": true,
    "slds-grid": true,
    "slds-grid_vertical-align-center": true
  },
  key: 8
};
const stc5 = {
  key: 13
};
const stc6 = {
  props: {
    "iconName": "utility:download",
    "size": "x-small",
    "iconClass": "normal"
  },
  key: 16
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, b: api_bind} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.showFailed ? api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(2, null, api_dynamic_text($cmp.labels.downloadFailureReport))]), api_element("div", stc1, [api_element("div", stc2, [api_custom_element("c360-icon", _c360Icon, stc3)]), api_static_fragment($fragment2, 7, [api_static_part(1, null, api_dynamic_text($cmp.labels.reviewFailureReport))]), api_element("div", stc4, [$cmp.isLoadingReport ? api_static_fragment($fragment3, 10, [api_static_part(3, null, api_dynamic_text($cmp.sharedLabels.loading))]) : null, $cmp.isLoadingReport ? api_static_fragment($fragment4, 12, [api_static_part(1, null, api_dynamic_text($cmp.sharedLabels.loading))]) : null, !$cmp.isLoadingReport ? api_custom_element("page-link", _pageLink, stc5, [api_static_fragment($fragment5, 15, [api_static_part(0, {
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.downloadFailedReportLink))
    }
  }, null), api_static_part(1, {
    attrs: {
      "title": $cmp.labels.downloadFailedReport
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.downloadFailedReport))])]) : null, !$cmp.isLoadingReport ? api_custom_element("c360-icon", _c360Icon, stc6) : null])])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2ojoh7ccvgk";
tmpl.legacyStylesheetToken = "appx-securityReviewSubmissionFailed_securityReviewSubmissionFailed";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
